/** A credential-free marker prevents a reload from falling back to another account. */
import { create } from "zustand";
export function hasRoleModeMarker() {
  return new URLSearchParams(window.location.search).get("role") === "link";
}
const key = "scorio.role-entry.active";
function remembered(): boolean {
  try {
    return sessionStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}
export const useRoleMode = create<{ active: boolean }>(() => ({
  active: remembered() || hasRoleModeMarker(),
}));
export function enterRoleMode() {
  try {
    sessionStorage.setItem(key, "1");
  } catch {
    /* Memory mode still works when storage is blocked. */
  }
  useRoleMode.setState({ active: true });
}
export function leaveRoleMode() {
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* No credential is stored here. */
  }
  useRoleMode.setState({ active: false });
}
